import React, { Suspense, useEffect, useRef, useState } from "react";

const ReCAPTCHA = React.lazy(() => import("react-google-recaptcha"));

export default function ViewportRecaptcha(props) {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!("IntersectionObserver" in window)) {
      setIsVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.01 }
    );

    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={containerRef}
      data-recaptcha-placeholder
      style={{ minHeight: "78px" }}
    >
      {isVisible && (
        <Suspense fallback={null}>
          <ReCAPTCHA {...props} />
        </Suspense>
      )}
    </div>
  );
}
